import { render } from "./cpt-video-player.vue?vue&type=template&id=56d0443a"
import script from "./cpt-video-player.vue?vue&type=script&lang=js"
export * from "./cpt-video-player.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__